// 运行时配置
import { BRAND_LOGO } from '@/constants';
import services from '@/services';
import { ProLayoutProps } from '@ant-design/pro-components';
import type { RunTimeLayoutConfig } from '@umijs/max';
import { history } from '@umijs/max';
import type { MenuProps } from 'antd';
import { Dropdown } from 'antd';
import proLayoutSettings from '../config/proLayoutSettings';
import requestConfig from '../config/requestConfig';
import { removeTokenCookie } from './utils/auth';

const loginPath = '/login';
const defaultAvatar = BRAND_LOGO;

// 全局初始化数据配置，用于 Layout 用户信息和权限初始化
// 更多信息见文档：https://next.umijs.org/docs/api/runtime-config#getinitialstate
export async function getInitialState(): Promise<{
  settings: ProLayoutProps;
  loading?: boolean;
  userInfo: any;
  fetchUserInfo?: () => Promise<any>;
}> {
  let userInfo = {};
  const { location } = history;

  const fetchUserInfo = async () => {
    try {
      const { data: userInfo } = await services.AdminController.queryUserInfo();
      return userInfo;
    } catch {
      history.push(loginPath);
    }
  };

  // 如果不是登录页面，执行
  if (location.pathname !== loginPath) {
    userInfo = await fetchUserInfo();
  }

  return {
    userInfo,
    fetchUserInfo,
    settings: proLayoutSettings,
  };
}

export const layout: RunTimeLayoutConfig = ({ initialState }) => {
  const { userInfo = {}, settings = {} } = initialState || {};

  const handleLogout = () => {
    removeTokenCookie();

    const { search, pathname } = window.location;
    const urlParams = new URL(window.location.href).searchParams;
    const redirect = urlParams.get('redirect');

    if (window.location.pathname !== loginPath && !redirect) {
      history.replace({
        pathname: loginPath,
        search: `?redirect=${pathname}${search}`,
      });
    }
  };

  const { logo, layout, menu, fixSiderbar } = settings;

  return {
    logo,
    menu,
    layout,
    fixSiderbar,
    avatarProps: {
      src: userInfo.avatar || defaultAvatar,
      title: userInfo.name || '余光',
      render: (_, avatarChildren) => {
        const items: MenuProps['items'] = [
          {
            key: 'logout',
            label: (
              <a
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => handleLogout()}
              >
                退出登录
              </a>
            ),
          },
        ];

        return (
          <Dropdown menu={{ items }} placement="bottom" arrow>
            {avatarChildren}
          </Dropdown>
        );
      },
    },
  };
};

/**
 * @name request 请求配置
 * 它基于 axios 和 ahooks 的 useRequest 提供了一套统一的网络请求和错误处理方案。
 * @doc https://umijs.org/docs/max/request#配置
 */
export const request = {
  ...requestConfig,
};
